<template>
<div class="site container hfeed">
  <HeadNav selectedLanguage="en" page="download" />
  <article class="seo-topic-page">
    <SeoBreadcrumb :items="breadcrumbItems" />
    <section class="blog-content download-page">
      <div class="download-page__hero">
        <img src="@/assets/gb-wave-logo.webp" alt="GB WhatsApp" class="download-page__logo" width="96" height="96">
        <h1>Download GB WhatsApp APK for Android (v18.80)</h1>
        <button type="button" class="gb-wave-btn gb-wave-btn--primary" @click="triggerDownload">⬇ Download APK</button>
      </div>

      <h2>APK Information</h2>
      <div class="apk-info-strip" role="list">
        <div
          v-for="item in infoBox"
          :key="item.label"
          class="apk-info-strip__item"
          role="listitem"
        >
          <span class="apk-info-strip__icon" aria-hidden="true">{{ item.icon }}</span>
          <span class="apk-info-strip__label">{{ item.label }}</span>
          <span class="apk-info-strip__value">{{ item.value }}</span>
        </div>
      </div>

      <h2>What's New</h2>
      <p>The latest release focuses on improving performance, fixing common bugs, and enhancing compatibility with newer Android devices. It also includes refinements to privacy controls, smoother media sharing, and a more stable messaging experience for everyday use.</p>
      <ul>
        <li>Improved app stability</li>
        <li>Better Android compatibility</li>
        <li>Enhanced privacy settings</li>
        <li>Bug fixes and optimizations</li>
      </ul>

      <h2>How to Install</h2>
      <p>Installing <router-link to="/">GB WhatsApp</router-link> only takes a few minutes.</p>
      <ol class="install-timeline">
        <li class="install-timeline__item">
          <span class="install-timeline__dot" aria-hidden="true">1</span>
          <div class="install-timeline__body">Download the latest APK.</div>
        </li>
        <li class="install-timeline__item">
          <span class="install-timeline__dot" aria-hidden="true">2</span>
          <div class="install-timeline__body">Enable <strong>Install Unknown Apps</strong> in Android Settings.</div>
        </li>
        <li class="install-timeline__item">
          <span class="install-timeline__dot" aria-hidden="true">3</span>
          <div class="install-timeline__body">Open the downloaded file and complete the installation.</div>
        </li>
        <li class="install-timeline__item">
          <span class="install-timeline__dot" aria-hidden="true">4</span>
          <div class="install-timeline__body">Verify your phone number and restore your backup if available.</div>
        </li>
      </ol>
      <blockquote class="home-note"><strong>Tip:</strong> Back up your chats before updating to avoid losing important conversations.</blockquote>
      <p><router-link to="/old-versions/">Need an older build? Browse GB WhatsApp old versions</router-link></p>
    </section>
  </article>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/seo-guide-page.scss';
import '@/css/gb-wave-home.scss';
import HeadNav from '@/components/HeadNav.vue';
import SeoBreadcrumb from '@/components/SeoBreadcrumb.vue';
import apkDownload from '@/mixins/apkDownload';

export default {
  name: 'Download',
  components: { HeadNav, SeoBreadcrumb },
  mixins: [apkDownload],
  data() {
    return {
      breadcrumbItems: [
        { label: 'Home', to: { name: 'en-gb' } },
        { label: 'Download', current: true },
      ],
      infoBox: [
        { icon: '📦', label: 'Version', value: 'v18.80' },
        { icon: '📱', label: 'Android', value: '5.0+' },
        { icon: '💾', label: 'File Size', value: '95 MB' },
        { icon: '📅', label: 'Updated', value: 'Oct 2026' },
        { icon: '🌎', label: 'Language', value: 'Multi-language' },
        { icon: '💰', label: 'License', value: 'Free' },
      ],
    };
  },
};
</script>

<style scoped>
/* 下载页居中标题：去掉全局 H1 左侧绿短线 */
.download-page ::v-deep h1::after {
  display: none;
}

.download-page__hero {
  text-align: center;
  margin-bottom: 2rem;
}
.download-page__logo {
  margin-bottom: 1rem;
}
.apk-info-strip {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  margin: 1.1rem 0 2.25rem;
  padding: 0;
  list-style: none;
}

.apk-info-strip__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  min-height: 118px;
  padding: 14px 10px 12px;
  text-align: center;
  background: linear-gradient(180deg, #ffffff 0%, #f7fcf9 100%);
  border: 1px solid rgba(40, 167, 69, 0.14);
  border-radius: 14px;
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.9) inset,
    0 8px 22px rgba(18, 76, 43, 0.06);
  transition:
    transform 0.22s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.22s ease,
    border-color 0.22s ease;
}

.apk-info-strip__item:hover {
  transform: translateY(-2px);
  border-color: rgba(40, 167, 69, 0.28);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.9) inset,
    0 14px 28px rgba(18, 76, 43, 0.1);
}

.apk-info-strip__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  font-size: 1.15rem;
  line-height: 1;
  border-radius: 10px;
  background: rgba(40, 167, 69, 0.1);
}

.apk-info-strip__label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6b7585;
  line-height: 1.2;
}

.apk-info-strip__value {
  font-size: 0.92rem;
  font-weight: 800;
  color: var(--gb-wave-ink, #0d3d2a);
  line-height: 1.25;
  word-break: break-word;
}

@media (max-width: 900px) {
  .apk-info-strip {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
  }

  .apk-info-strip__item {
    min-height: 108px;
    padding: 12px 8px;
  }
}

@media (max-width: 520px) {
  .apk-info-strip {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 4px;
    margin-right: -8px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
  }

  .apk-info-strip__item {
    flex: 0 0 108px;
    min-height: 104px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .apk-info-strip__item {
    transition: none;
  }

  .apk-info-strip__item:hover {
    transform: none;
  }
}
.home-note {
  background: #f0f7f4;
  border-left: 4px solid var(--gb-wave-green);
  padding: 12px 16px;
  margin: 1rem 0;
}
</style>
